// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3Ogk_","cell":"ColumnAccessor_cell__3hbT7","firstCellAccent":"ColumnAccessor_firstCellAccent__2vIu3"};